export default __webpack_public_path__ + "static/media/13.8a88d443.webp";